import { BroadcastChannel, BroadcastChannelOptions } from 'broadcast-channel'

const defaultChannel = "BCAPI"
const channels: Record<string, BroadcastChannel> = {}

export function channel(channelName: string = defaultChannel, options?: BroadcastChannelOptions) {
  return channels[channelName]
    || (channels[channelName] = new BroadcastChannel(channelName, options))
} 
